// src/utility/FacebookPixel.ts

import ReactPixel from 'react-facebook-pixel';

// ✅ Pixel ID constant (keep consistent across app)
export const FACEBOOK_PIXEL_ID = '246752335900027';

// Facebook Pixel initialization options
interface PixelOptions {
  autoConfig: boolean;
  debug: boolean;
}

// Track if pixel is already initialized
let pixelInitialized = false;

/**
 * Initialize Facebook Pixel ONCE at app startup
 * @param pixelId - Your Facebook Pixel ID
 * @param options - Optional configuration options
 */
export const initFacebookPixel = (
  pixelId: string = FACEBOOK_PIXEL_ID,
  options: Partial<PixelOptions> = {}
): void => {
  // Check if base pixel code already loaded (from HTML)
  if ((window as any).fbq && typeof (window as any).fbq === 'function') {
    pixelInitialized = true;

    // Initialize ReactPixel to use existing fbq instance
    const isLocalhost =
      window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const defaultOptions: PixelOptions = {
      autoConfig: false, // Don't auto-config since base code already did
      debug: isLocalhost,
    };

    try {
      ReactPixel.init(pixelId, undefined, { ...defaultOptions, ...options });
    } catch (error) {
    }
    return;
  }

  // Fallback: Initialize via ReactPixel if base code not found
  if (pixelInitialized) {
    return;
  }

  const isLocalhost =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  const defaultOptions: PixelOptions = {
    autoConfig: true,
    debug: isLocalhost, // Enable debug mode on localhost
  };

  try {
    ReactPixel.init(pixelId, undefined, { ...defaultOptions, ...options });
    pixelInitialized = true;

    // Verify pixel is loaded
    if ((window as any).fbq) {
    } else {
    }
  } catch (error) {
  }
};

/**
 * Check if pixel is initialized (either via base code or ReactPixel)
 */
export const isPixelInitialized = (): boolean => {
  return pixelInitialized || !!(window as any).fbq;
};
